var map = {
	"./advices.jpg": 27578,
	"./blogs.jpg": 97406,
	"./cards.jpg": 69685,
	"./credits.jpg": 72111,
	"./insurance.jpg": 74733,
	"./investments.jpg": 96527,
	"./main.jpg": 27312,
	"./news.jpg": 21519,
	"./realEstate.jpg": 7656,
	"./savings.jpg": 38953,
	"./specials.jpg": 50482,
	"./tests.jpg": 56338
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87121;